import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Plane, Dice5, Home, Rocket } from "lucide-react";
import BetslipIcon from "./BetslipCount";
import { useSelector } from "react-redux";

const BottomNavigation = ({ onBetslipClick, showBetslip = true }) => {
  const { bets } = useSelector((state) => state.betSlip);
  const location = useLocation();

  // All navigation items
  const navItems = [
    { name: "HOME", icon: <Home size={20} />, path: "/", isLink: true },
    {
      name: "CASINO",
      icon: <Dice5 size={20} />,
      path: "/casino",
      isLink: true,
    },
    {
      name: "",
      icon: <BetslipIcon count={bets.length} />,
      handler: onBetslipClick,
      isLink: false,
      isBetslip: true,
    },
    {
      name: "AVIATOR",
      icon: <Plane size={20} />,
      path: "/game/avaitor?provider=aviator&mode=real",
      isLink: true,
    },
    {
      name: "JETX",
      icon: <Rocket size={20} />,
      path: "/game/jetx?provider=jetx&mode=real",
      isLink: true,
    },
  ];

  // Filter items based on showBetslip
  const displayItems = showBetslip
    ? navItems
    : navItems.filter((item) => !item.isBetslip);

  // Render navigation item
  const renderNavItem = (item, index) => {
    const isBetslip = item.isBetslip;

    // Base classes for all items
    const baseClasses = "flex flex-col items-center justify-center relative";

    // Container classes - betslip gets special treatment
    const containerClasses = isBetslip
      ? "flex flex-col items-center justify-end h-full"
      : "flex flex-col items-center justify-center h-full px-2 py-2";

    // Icon wrapper classes - circular background for betslip only
    const iconWrapperClasses = isBetslip
      ? "bg-yellow rounded-full p-3 shadow-lg transform -translate-y-2 flex items-center justify-center"
      : "";

    const iconClasses = isBetslip ? "text-bluedarkmode" : "text-yellow";
    const textClasses = isBetslip
      ? "text-white text-xs mt-1"
      : "text-white text-xs mt-1";

    if (item.isLink) {
      return (
        <div key={index} className={containerClasses}>
          <Link to={item.path} className={baseClasses}>
            <div className={iconWrapperClasses}>
              <span className={iconClasses}>{item.icon}</span>
            </div>
            <span className={textClasses}>{item.name}</span>
          </Link>
        </div>
      );
    } else {
      return (
        <div key={index} className={containerClasses}>
          <button onClick={item.handler} className={baseClasses}>
            <div className={iconWrapperClasses}>
              <span className={iconClasses}>{item.icon}</span>
            </div>
            <span className={textClasses}>{item.name}</span>
          </button>
        </div>
      );
    }
  };

  return (
    <div className="md:hidden fixed bottom-0 z-[9] w-full bg-bluedarkmode dark:bg-bluedarkmode">
      <div className="grid grid-cols-5 h-16 items-end pb-2">
        {displayItems.map((item, index) => (
          <div key={index} className="flex justify-center">
            {renderNavItem(item, index)}
          </div>
        ))}

        {/* Empty grid cells to maintain spacing when betslip is hidden */}
        {!showBetslip && (
          <div className="flex justify-center">
            <div className="invisible">
              {/* Invisible placeholder to maintain grid structure */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BottomNavigation;
